<template>
  <v-container>
      <!--パンくずリスト-->
    <v-breadcrumbs :items="breadcrumbs">
      <v-breadcrumbs-item
      exact
      slot="item"
      slot-scope="{ item }"
      :to="item.href"
      :disabled="showLink(item.href)">
        {{ item.name }}
      </v-breadcrumbs-item>
    </v-breadcrumbs>
    <Content></Content>
  </v-container>
</template>

<script>
import Content from '../components/Investigation/Content'

export default {
  components: {
    Content
  }
}
</script>
<script>
import Content from '../components/Investigation/Content'
export default {
  name: 'Breadcrumbs',
  data: () => ({
    default: {
      name: '',
      href: ''
    },
    // パンくずリスト
    breadcrumbs: [
      {
        name: 'ホーム',
        href: '/'
      },
      {
        name: 'サービス',
        href: '/Service'
      },
     {
        name: '研究開発',
        href: 'Investigation'
      }
    ]
  }),
  methods: {
    // 現在のパス以外はリンクをつけない
    showLink (path) {
      var currentPath = this.$route.path
      if (path === currentPath) {
        return true
      } else {
        return false
      }
    }
  },
  components: {
    Content
  }
}
</script>
